import React from 'react';
import classnames from 'classnames';
import GPSelect from '@gp/components/Select';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IPureSelectProps extends IBaseProps, IGPSelectProps {}

const PureSelect: React.FC<IPureSelectProps> = (props) => {
  const { className, searchable = true, listWidth = 200, ...restProps } = props;

  return (
    <GPSelect
      {...restProps}
      className={classnames('dbg-common-pure-select', className)}
      appearance="default"
      searchable={searchable}
      listWidth={listWidth}
    />
  );
};

export default React.memo(PureSelect);
